// 發票類型選項
export const INVOICE_ISSUING_TYPE_OPTIONS = [
    {
        text: '捐贈發票',
        value: 1,
    },
    {
        text: '二聯式發票',
        value: 2,
    },
    {
        text: '三聯式發票',
        value: 3,
    },
];

// 發票載具類型
export const INVOICE_CARRIER_TYPE = {
    MEMBER: 1, // 會員載具
    MOBILEBARCODE: 2, // 手機條碼
    CITIZENDIGITALCERTIFICATE: 3, // 自然人憑證載具
    SMSSENT: 4, // 簡訊寄送
};

// 預設愛心碼 勵馨基金會
export const DEFAULT_LOVE_CODE_LICHING_FOUNDATION = '9118595';

export const DEFAULT_DONATE_OPTIONS = [
    {
        text: `勵馨基金會 ${DEFAULT_LOVE_CODE_LICHING_FOUNDATION}`,
        value: `${DEFAULT_LOVE_CODE_LICHING_FOUNDATION}`,
    },
];
